/**
 * Get the context menu top position based off the given node's position
 */
export function getPositionTop(
  menuRect: { width: number; height: number },
  nodeRect: DOMRect | null | undefined,
): number {
  if (!nodeRect) {
    return 0;
  }

  // top edge of menu on bottom edge of node
  const belowNodeYPosition = nodeRect.y + nodeRect.height;

  // bottom edge of menu on top edge of node
  const aboveNodeYPosition = nodeRect.y - menuRect.height;

  const menuCanFitBelowNode = belowNodeYPosition <= window.innerHeight - menuRect.height;
  const menuCanFitAboveNode = aboveNodeYPosition >= 0;

  if (!menuCanFitBelowNode && !menuCanFitAboveNode) {
    return 0;
  }

  if (!menuCanFitBelowNode) {
    return aboveNodeYPosition;
  }

  return belowNodeYPosition;
}

/**
 * Get the context menu left position based off the given node's position
 */
export function getPositionLeft(
  menuRect: { width: number; height: number },
  nodeRect: DOMRect | null | undefined,
): number {
  if (!nodeRect) {
    return 0;
  }

  // left edge of menu on left edge of node
  const rightOfNodeXPosition = nodeRect.x;

  // right edge of menu on right edge of node
  const leftOfNodeXPosition = nodeRect.x + nodeRect.width - menuRect.width;

  const menuCanFitRightOfNode = rightOfNodeXPosition <= window.innerWidth - menuRect.width;
  const menuCanFitLeftOfNode = leftOfNodeXPosition >= 0;

  if (!menuCanFitRightOfNode && !menuCanFitLeftOfNode) {
    return 0;
  }

  if (!menuCanFitRightOfNode) {
    return leftOfNodeXPosition;
  }

  return rightOfNodeXPosition;
}
